import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	groupByLabel: {
		id: 'issue-table-group-by-dropdown.group-by-label',
		defaultMessage: 'Group',
		description: 'Label for the dropdown allowing users to select what way to group issues by',
	},
	groupByLabelWithSelection: {
		id: 'issue-table-group-by-dropdown.group-by-label-with-selection',
		defaultMessage: 'Group: {groupByField}',
		description:
			'Label for the dropdown allowing users to select what way to group issues by when a user has selected a grouping',
	},
});
